import { IEventModule } from "app/event/model"
import { CampaignAPI } from "generated-api"

export const DEFAULT_RADIUS_VALUE: string = "1"
export const TYPE_COORDINATE = "COORDINATE"

export enum COORDINATE_EVENTS {
  COORDINATE_ADD = "COORDINATE_ADD",
  COORDINATE_UPDATE = "COORDINATE_UPDATE",
  COORDINATE_DELETE = "COORDINATE_DELETE",
  COORDINATES_DELETE = "COORDINATES_DELETE",
  COORDINATES_SET = "COORDINATES_SET"
}

export interface ICoordinateData {
  name: string
  longitude: number
  latitude: number
  radius: number // unit is always km
}

export type ICoordinateDTO = Awaited<ReturnType<typeof CampaignAPI.getApiCampaignCoordinateList>>[0]
export interface ICoordinate extends ICoordinateDTO, ICoordinateData {
  type: "COORDINATE"
}

export interface ICoordinateRepository {
  getCoordinates(campaignId: number): Promise<ICoordinate[]>
  createCoordinate(campaignId: number, coordinate: ICoordinate): Promise<ICoordinate>
  createCoordinates(campaignId: number, coordinates: ICoordinate[]): Promise<ICoordinate[]>
  updateCoordinate(campaignId: number, coordinate: ICoordinate): Promise<void>
  setCoordinates(campaignId: number, coordinates: ICoordinateData[]): Promise<ICoordinate[]>
  deleteCoordinate(campaignId: number, coordinateId: number): Promise<void>
}

export interface ICoordinateEventModule extends IEventModule {
  on: {
    onCoordinateAdd(listenerId: string, fn: (coordinate: ICoordinate) => void): void
    onCoordinateUpdate(listenerId: string, fn: (coordinate: ICoordinate) => void): void
    onCoordinateDelete(listenerId: string, fn: (coordinateId: number) => void): void
    onCoordinatesDelete(listenerId: string, fn: (coordinateIds: number[]) => void): void
    onCoordinatesSet(listenerId: string, fn: (coordinates: ICoordinate[]) => void): void
  }
}
